import * as React from 'react'
import { Link } from 'react-router-dom'
import { StoresContext } from './Context/Stores'
import SVG from './SVG'

const StoreMenu = ({ onClose, children }) => {
  const storesCtx = React.useContext(StoresContext)
  const { stores, store: selectedStore } = storesCtx

  console.log({ stores })

  // Ensure selected store at top of list.
  const sortedStores = [
    stores.find((s) => s.bc_hash === selectedStore.bc_hash),
    ...stores.filter((s) => s.bc_hash !== selectedStore.bc_hash),
  ].filter((s) => s)

  // Default to the 1st channel--the default storefront
  const selectStorefront = (store, channel = { id: 1 }) => {
    storesCtx.selectChannel(store.bc_hash, channel.id)
    if (onClose) {
      onClose()
    }
  }

  return (
    <>
      {sortedStores.map((store) => {
        const isSelectedStore = store.bc_hash === selectedStore.bc_hash

        return (
          <div key={store.bc_hash} className="flex flex-col gap-0.5">
            <button
              onClick={() => selectStorefront(store)}
              type="button"
              className={`p-2 w-full rounded-md relative text-left transition flex items-center gap-1.5 hover:bg-indigo-700 sm:hover:bg-indigo-500 hover:text-white text-white sm:text-black ${
                isSelectedStore
                  ? 'bg-indigo-900 sm:bg-indigo-100'
                  : 'bg-transparent'
              }`}
            >
              {store.bc_name}
            </button>
          </div>
        )
      })}

      <div className="rounded-md bg-indigo-500/50 sm:bg-gray-100/80 p-1 text-white sm:text-black">
        <Link
          onClick={onClose}
          to="/stores"
          className="p-2 transition flex items-center gap-1 hover:text-indigo-100 sm:hover:text-indigo-500 group"
        >
          <SVG
            name="gear"
            className="w-5 h-5 text-indigo-400 sm:text-gray-400 group-hover:text-white sm:group-hover:text-indigo-500"
          />
          Manage stores
        </Link>
        {children}
      </div>
    </>
  )
}

export default StoreMenu
